<template>
  <base-dialog v-model="visible" header="隐私声明" @done="emits('done')">
    <template #content>
      <div class="text-right">生效日期：2025年7月17日</div>
      <div class="my-[10px]">
        <h4 class="mb-[10px]">引言</h4>
        <div>
          本隐私协议（以下简称“协议”）旨在告知您腾讯科技（深圳）有限公司（下称“我们”）如何收集、处理、存储和保护您在参加课程学习和考试中提供的个人信息。参加课程学习和考试，即表示您同意本协议的条款。
        </div>
      </div>
      <div class="mb-[10px]">
        <h4>1. 信息收集</h4>
        <div>
          我们可能会收集以下类型的信息：您可能会提供您的姓名、邮箱地址、手机号码、岗位信息等。我们不会无故收集比这更多或无关的信息。
        </div>
      </div>
      <div class="mb-[10px]">
        <h4>2. 信息使用</h4>
        <div>我们收集到的信息仅用于供应商员工课程培训与考试的信息备案。</div>
      </div>
      <div class="mb-[10px]">
        <h4>3. 信息共享</h4>
        <div>
          <div>我们不会将您的个人信息出售或出租给第三方。但在以下情况下，我们可能会与第三方共享您的信息：</div>
          <div>（1）得到您的明确授权；</div>
          <div>（2）为了履行法律义务或执行我们的协议；</div>
          <div>（3）为了保护我们的权利、财产或安全，或他人的权利、财产或安全。</div>
        </div>
      </div>
      <div class="mb-[10px]">
        <h4>4. 信息保护</h4>
        <div>我们采取适当的技术和组织措施来保护您的个人信息免受未经授权的访问、泄露、篡改或销毁。</div>
      </div>
      <div class="mb-[10px]">
        <h4>5. 数据保留</h4>
        <div>我们将根据法律法规的要求和提供服务所需的时间保留您的个人信息。</div>
      </div>
      <div class="mb-[10px]">
        <h4>6. 您的权利</h4>
        <div>您有权访问、更正、删除您的个人信息，或限制、反对其处理。您可以通过联系我们来行使这些权利。</div>
      </div>
      <div class="mb-[10px]">
        <h4>7. 隐私政策变更</h4>
        <div>我们可能会不时更新本隐私协议。如有重大变更，我们将在实施前通知您。</div>
      </div>
      <div class="mb-[10px]">
        <h4>8. 联系我们</h4>
        <div>如果您对本隐私协议有任何疑问或建议，请通过课程主页的【意见反馈】方式与我们联系。</div>
      </div>
      <div class="text-right">腾讯科技（深圳）有限公司</div>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { reportEvent, ReportEventName } from '@/utils/galileo';

import BaseDialog from './baseDialog.vue';

const emits = defineEmits(['done']);
const visible = defineModel<boolean>();

watch(visible, () => {
  if (visible.value) {
    reportEvent(ReportEventName.PrivacyPv);
  }
});
</script>
